/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * REBALANCE runs realize the full trade plan.
 * WITHDRAWAL runs only raise the withdrawal mandate - SELL is capped at the min sell constraint and TLH is suppressed (the goal is a sell only run).
 * @export
 */
export const RunMode = {
    REBALANCE: 'rebalance',
    WITHDRAWAL: 'withdrawal'
} as const;
export type RunMode = typeof RunMode[keyof typeof RunMode];


export function instanceOfRunMode(value: any): boolean {
    for (const key in RunMode) {
        if (Object.prototype.hasOwnProperty.call(RunMode, key)) {
            if (RunMode[key as keyof typeof RunMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RunModeFromJSON(json: any): RunMode {
    return RunModeFromJSONTyped(json, false);
}

export function RunModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunMode {
    return json as RunMode;
}

export function RunModeToJSON(value?: RunMode | null): any {
    return value as any;
}

export function RunModeToJSONTyped(value: any, ignoreDiscriminator: boolean): RunMode {
    return value as RunMode;
}

